import { render, staticRenderFns } from "./RoutingMTK.vue?vue&type=template&id=63af3afa&scoped=true"
import script from "./RoutingMTK.vue?vue&type=script&lang=js"
export * from "./RoutingMTK.vue?vue&type=script&lang=js"
import style0 from "./RoutingMTK.vue?vue&type=style&index=0&id=63af3afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af3afa",
  null
  
)

export default component.exports